// Turn Django REST Framework validation errors into messages a teacher can act
// on, instead of showing "question_ids: Ensure this field has no more than 200
// elements." Unknown fields and messages pass through unchanged.

// Keep in sync with the backend: math_bank HANDOUT_RECORD_MAX_QUESTIONS and the
// bank Word export serializer. Bilingual exam papers stay at 200.
export const HANDOUT_MAX_QUESTIONS = 400;
export const BILINGUAL_MAX_QUESTIONS = 200;

const fieldLabels = {
  question_ids: "題目",
  title: "名稱",
  filename: "檔名",
  notes: "備註",
  template_id: "模板",
  record_payload: "講義版面",
  payload: "講義版面",
  expected_updated_at: "紀錄版本",
  request_id: "請求編號",
};

const translations = [
  [/^Ensure this field has no more than (\d+) elements\.?$/i, (key, max) => key === "question_ids"
    ? `題目數量超過上限，一次最多 ${max} 題。請減少題目，或分成數份後再儲存／匯出。`
    : `最多 ${max} 項。`],
  [/^Ensure this field has at least (\d+) elements?\.?$/i, (key, min) => key === "question_ids"
    ? `至少需要 ${min} 題。` : `至少需要 ${min} 項。`],
  [/^Ensure this field has no more than (\d+) characters\.?$/i, (key, max) => `最多 ${max} 個字。`],
  [/^This field is required\.?$/i, () => "為必填。"],
  [/^This field may not be blank\.?$/i, () => "不可空白。"],
  [/^This list may not be empty\.?$/i, () => "不可為空。"],
  [/^Must be a valid UUID\.?$/i, (key) => key === "question_ids" ? "含有格式錯誤的題目 ID。" : "ID 格式錯誤。"],
  [/^Expected a list of items but got type/i, () => "格式錯誤，需為清單。"],
];

const translate = (key, message) => {
  for (const [pattern, render] of translations) {
    const match = String(message).match(pattern);
    if (match) return render(key, ...match.slice(1));
  }
  return null;
};

// The backend already words its own validation messages in Chinese; those are
// complete sentences and need no "record_payload:" style field prefix.
const isReadableSentence = (message) => /[\u3400-\u9fff]/.test(String(message || ""));

// Message for one `field: message` pair; null when nothing is known about it.
export const formatFieldError = (key, message) => {
  if (isReadableSentence(message)) return String(message);
  const translated = translate(key, message);
  if (!translated) return null;
  // The question limit message is a full sentence on its own.
  if (key === "question_ids" && /上限|至少|格式錯誤/.test(translated)) return translated;
  return `${fieldLabels[key] || key}${translated}`;
};

export const translateApiErrorText = (message) => translate("", message) || message;
